<template>
	<div class="oms-payload">
			
		<div class="card-item">
			<div class="card-header">功能调试</div>
			<div class="card-payload">
				<van-grid>
					<template v-for="(item,idx) in debugItem">
						<van-grid-item 
							:icon="item.icon" 
							:text="item.label" 
							@click="handleSend(idx)"
						/>
					</template>
				</van-grid>
			</div>
		</div>

	</div>
</template>

<script type="text/javascript">
import {getQwSignature} from '@/interface/qywx/qwglobal';

export default {
    data(){
    	return {
    		//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qwQuan',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
    		debugItem:[
    			{label:'获取客户群ID', key:'CurExternalChat', icon:'miniprogram-o'},
    			{label:'分享文本消息', key:'ChatMessage', icon:'shop-o'},
    			{label:'分享小程序', key:'shareMiniProgram', icon:'shop-o'},
    		],
    	}
    },
    created: function() {
    	this.getQywxCfg();
    },
    methods:{
    	handleSend: function(idx){
			let current = this.debugItem[idx];

			if( current.key == 'CurExternalChat' ){
				//获取群ID
				this.handleCurExternalChat();
			}else if( current.key == 'ChatMessage' ){
				//发送群消息
				this.handleChatMessage();
			}else if( current.key == 'shareMiniProgram' ){
				this.handleMiniProgram();
			}
		},
    	//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		//发送群消息
		handleChatMessage: function(){
			ww.sendChatMessage({
				msgtype: 'text',
				text: {
					content: '你好'
				},
				success(res){
					alert('全消息发送成功:'+JSON.stringify(res));
				},
				fail(err){
					alert('全消息发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ChatMessage-complete:'+JSON.stringify(res));
				}
			})
		},
		//分享小程序
		handleMiniProgram: function(){
			let pageUrl = 'pages/tabbar/pmall/pmall.html';
				pageUrl+= '?thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;
			alert(pageUrl);

			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: 'wx9ed82a18f13f2603',
					title: '云卡维修连锁',
					imgUrl: 'http://imageoss.yuntruck.com/202411/173129787369482.png',
					page: pageUrl,
				},
				success(res){
					alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		}
    }
}
</script>